import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { DataQualityWarningAssetFragmentGql } from './DataQualityWarningAssetFragmentGql';
import { DataQualityWarningFragmentGql } from './DataQualityWarningFragmentGql';

export const VirtualConnectionLineageUpstreamDataQualityWarningsQueryGql: DocumentNode = gql`
query VirtualConnectionLineageUpstreamDataQualityWarningsQuery($vizportalUrlId: String!, $first: Int!, $offset: Int!, $publishedConnectionsLineageEnabled: Boolean!) {
  virtualConnections(filter: { vizportalUrlId: $vizportalUrlId }) {
    id
    upstreamDataQualityWarningsConnection(filter: {isActive: true},
                                          first: $first, offset: $offset,
                                          orderBy: {field: IS_SEVERE, direction: DESC}) {
      totalCount
      nodes {
        ...DataQualityWarningFragment
        ...DataQualityWarningAssetFragment
      }
    }
  }
}
${DataQualityWarningFragmentGql}
${DataQualityWarningAssetFragmentGql}
`;
